import { TFunction } from 'i18next';
import { EventMarker } from '@hotjar/webapp/features/Playbacks/types';
import { getMinutesAndSeconds } from '@hotjar/insights-common/lib/getMinutesAndSeconds';
import { getCleanSelector } from './getCleanSelector';

export const getEventTooltip = (eventMarker: EventMarker, t: TFunction): string => {
  switch (eventMarker.type) {
    case 'page':
      return `${eventMarker.url}\n\n${t('common:player.sidebar.duration-on-page', {
        duration: getMinutesAndSeconds(eventMarker.duration),
      })}`;
    case 'input_choice_change':
    case 'select_change':
    case 'key_press': {
      const cleanSelector = getCleanSelector(eventMarker.selector);
      const extraInfo =
        eventMarker.suppression && eventMarker.suppression === 'full'
          ? t('common:player.sidebar.data-suppressed')
          : t('common:player.sidebar.to', { target: eventMarker.text || eventMarker.value });
      return `${cleanSelector} ${extraInfo}`;
    }
    case 'mouse_click':
      return getCleanSelector(eventMarker.selector);
    case 'tag_recording':
      return eventMarker.name ?? '';
    case 'autotag_recording': {
      return eventMarker.description ?? t('common:player.sidebar.unknown-action');
    }
    default:
      return t('common:player.sidebar.unknown-action');
  }
};
